import gql from "graphql-tag";

export const allFields = gql`
	fragment OrderAllFields on Perpetual {
		id
		serialNumberID
		serialNumber
		licenseName
		order {
			orderNumber
			orderDate
			isSerialNumberGenerationPending
		}
		product {
			description
		}
	}
`;
